import { Modal } from "components";
import { ButtonSecondary, ButtonWarning } from "components/Atoms/Button";
import { TextArea } from "components/Atoms/formInputs/TextArea";
import React, { useState } from "react";

interface Props {
  title: string
  declinedReason: string
  isDeclining: boolean
  onCancel: () => void
  onDecline: (declinedReason: string) => void
}

export const DeclineFormRowModal = (props: Props) => {
  const [declinedReason, setDeclinedReason] = useState(props.declinedReason ?? "");

  return <Modal
    isOpen
    handleClose={props.onCancel}
    title={props.title}
    width="tiny"
  >
    <TextArea
      value={declinedReason}
      onChange={setDeclinedReason}
      placeholder={RESX.Advancing.DeclinedResponseReasonPlaceholder}
      maxLength={serverReference.constants.advancing.maxDeclinedReasonLength}
      rows={4}
      focusOnMount
      onCtrlEnter={() => props.onDecline(declinedReason)}
    />
    <div className="flex gap justify-end">
      <ButtonSecondary label={RESX.Buttons.btnCancel} onClick={props.onCancel} disabled={props.isDeclining} />
      <ButtonWarning label={RESX.Buttons.Decline} onClick={() => props.onDecline(declinedReason)} loading={props.isDeclining} disabled={props.isDeclining} />
    </div>
  </Modal>;
};
